module.exports = __webpack_public_path__ + "static/sport/Form.1d257df.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/Form.webp
// module id = XQMZ
// module chunks = 0